// Inventory Outlets Actions
import Axios from 'axios'
import * as helpers from '@/mixins/helperFunctions.js'

// ***** Get outletsList from backend then update outletsList in vuex store ***** //
export const updateOutletsList = async ({ commit }, payload = null) => {
  let params = {}

  if (payload) {
    params = {
      search: payload.search,
      page: payload.page,
      per_page: payload.rowsPerPage,
      column: payload.sortBy,
      sortDir: payload.descending ? 'desc' : 'asc'
    }
  }

  try {
    const result = await Axios.get('outlets_index', { params: params })
    commit('updateOutletsList', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}

// ***** Fetch outlet from backend ***** //
export const fetchOutletInfo = async ({ commit }, payload = null) => {
  if (!helpers.checkId(payload)) {
    throw new Error('Error')
  }

  try {
    const result = await Axios.get(`outlets_show/${payload}`)
    commit('fetchOutletInfo', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}

// ***** Add outlet ***** //
export const addOutlet = async (ignored, payload = null) => {
  try {
    await Axios.post('outlets_store', payload)
    helpers.ktNotify({
      type: 'success',
      text: 'Added Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, creation failed')
  }
}

// ***** Update outlet info ***** //
export const updateOutletInfo = async (ignored, payload = null) => {
  if (!helpers.checkId(payload.id)) {
    throw new Error('Error')
  }

  try {
    payload.formData.append('_method', 'PATCH')
    await Axios.post(`outlets_update/${payload.id}`, payload.formData)
    helpers.ktNotify({
      type: 'success',
      text: 'Updated Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, update failed')
  }
}

// ***** Delete outlet ***** //
export const deleteOutlet = async (ignored, payload) => {
  if (!helpers.checkId(payload)) {
    throw new Error('Error')
  }

  try {
    await Axios.delete(`outlets_destroy/${payload}`)
    helpers.ktNotify({
      type: 'success',
      text: 'Deleted Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, deletion failed')
  }
}

export const setFullOutletsList = async ({ commit }) => {
  let outletsList = []

  try {
    const result = await Axios.get('outlets_list')
    result.data.data.forEach(outlet => {
      outletsList.push({ value: outlet.outlet_id, text: outlet.outlet_name })
    })
    commit('setFullOutletsList', outletsList)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, deletion failed')
  }
}
